import { Feature, InjectorService, ToolbarService } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { FIXED_KEYS_DOUBLE } from '@src/framework/workbench/schema/constant';

@Feature()
export class InsertPictureFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public async onClick() {
        const copyPasteImageService = await this.getAppService().editableServiceLayer?.copyPasteImageService?.promise();
        const { ImageEditManager } = copyPasteImageService ?? {};
        const imageManager = ImageEditManager?.getInstance();

        const input = document.getElementById('select_pic_input');
        input?.click();
        this.getAppService().viewableServiceLayer.toolbarStateManager.lastInsertButtonClick = 1;
        if (imageManager) {
            imageManager.imageReplacing = false;
        }
        try {
            this.twdReport();
        } catch (e) {
            console.log('insert image twd error');
        }
    }
}
